import { generateJsxKey } from '@utils/ast';
import { AudioComponent } from './organism.audio-component/_audio-component.js';
import { VideoComponentWrapper } from './organism.video-component/_video-component.js';
import { Video23Player } from './organism.video-component/atom.video23.js';
import { jsx } from 'react/jsx-runtime';

const printAudioComponent = (node, context) => {
  return /*#__PURE__*/jsx(AudioComponent, {
    isScrambled: node.pm2.isScrambled,
    caption: node.meta.caption,
    transcript: node.pm2.transcript,
    src: node.src,
    imageSrc: node.imageSrc
  }, generateJsxKey(context));
};
const print23VideoComponent = (node, context) => {
  return /*#__PURE__*/jsx(VideoComponentWrapper, {
    displayInternalInfoInPlayer: node.options.displayInternalInfoInPlayer,
    displayCaption: node.options.displayCaption,
    isScrambled: node.pm2.isScrambled,
    caption: node.meta.caption,
    children: /*#__PURE__*/jsx(Video23Player, {
      photoId: node.twentyThreeId,
      token: node.token,
      title: node.meta.caption.title?.value,
      caption: node.options.displayInternalInfoInPlayer ? node.meta.caption : undefined,
      aspectRatio: node.aspectRatio,
      showSubtitlesByDefault: node.options.showSubtitlesByDefault
    })
  }, generateJsxKey(context));
};
const mediaComponentJsxPrinters = {
  "audio-component": printAudioComponent,
  "23-video-component": print23VideoComponent
};

export { mediaComponentJsxPrinters, print23VideoComponent, printAudioComponent };
//# sourceMappingURL=printer.to-jsx.js.map
